/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

/* ===== Price filter: Apply button instead of auto-submit ===== */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var filterForm = document.querySelector('collection-filters-form');
    if (!filterForm) return;

    // Capture-phase listener blocks price input events from
    // reaching the theme's auto-submit handler on the sidebar
    filterForm.addEventListener('input', function (e) {
      if (
        e.target.hasAttribute('data-field-price-min') ||
        e.target.hasAttribute('data-field-price-max')
      ) {
        e.stopPropagation();
      }
    }, true);

    // Delegated click on the Apply button (survives AJAX re-renders)
    filterForm.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-price-apply]');
      if (!btn) return;

      var min = filterForm.querySelector('[data-field-price-min]');
      var max = filterForm.querySelector('[data-field-price-max]');
      if (min && !min.value) min.value = min.placeholder;
      if (max && !max.value) max.value = max.placeholder;

      filterForm.submitForm(new Event('click'));
    });

    // Enter key in either price field triggers Apply
    filterForm.addEventListener('keydown', function (e) {
      if (
        e.key === 'Enter' &&
        (e.target.hasAttribute('data-field-price-min') ||
          e.target.hasAttribute('data-field-price-max'))
      ) {
        e.preventDefault();
        var min = filterForm.querySelector('[data-field-price-min]');
        var max = filterForm.querySelector('[data-field-price-max]');
        if (min && !min.value) min.value = min.placeholder;
        if (max && !max.value) max.value = max.placeholder;

        filterForm.submitForm(new Event('click'));
      }
    });
  });
})();
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
